import { LitElement, html } from 'lit';
import fsTypography from '@cof/fs-typography-core/lib/typography.lit.min.js';
import { DebugService } from '../../shared/services/debug.service.js';
import { style } from './iconic-container.style.js';

export class RefiIconicContainer extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiIconicContainer');
    this.headerText = null;
    this.marketingOffer = null;
    this.ctaButtonText = null;
    this.returnButtonText = null;
    this.e2eId = '';
  }

  static properties = {
    headerText: { type: String },
    marketingOffer: { type: Object },
    ctaButtonText: { type: String },
    returnButtonText: { type: String },
    e2eId: { type: String },
  };

  static styles = [style, fsTypography];

  firstUpdated() {}

  connectedCallback() {
    super.connectedCallback();
  }

  render() {
    this.debug.log('rendered');
    return html`
      <div class="iconic-container" data-e2e-ref="${this.e2eId}">
        ${this.headerText
          ? html`
              <div class="header">
                <h1 class="header-text">${this.headerText}</h1>
                ${this.marketingOffer
                  ? html`
                      <h2 class="marketing-offer">
                        Your new ${this.marketingOffer.annualPercentRate}% APR
                        is waiting!
                      </h2>
                    `
                  : ''}
              </div>
            `
          : ''}
        <div>
          <slot></slot>
        </div>
        ${this.ctaButtonText
          ? html`
              <fs-button
                variant="primary"
                class="cta-button"
                @click="${this.ctaClicked}"
              >
                ${this.ctaButtonText}
              </fs-button>
            `
          : ''}
        ${this.returnButtonText
          ? html`
              <div class="return-cta">
                <fs-button
                  class="return-cta-button"
                  @click="${this.returnCtaClicked}"
                  tabindex="0"
                  ghost
                  compact
                  data-e2e-ref="return-cta"
                  >${this.returnButtonText}</fs-button
                >
              </div>
            `
          : ''}
      </div>
    `;
  }

  ctaClicked() {
    this.dispatchEvent(new CustomEvent('cta-clicked', { bubbles: true }));
  }

  returnCtaClicked() {
    this.dispatchEvent(
      new CustomEvent('return-cta-clicked', { bubbles: true })
    );
  }
}

customElements.define('refi-iconic-container', RefiIconicContainer);
